var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 88.2143C69.9859 88.2143 88.2143 69.9859 88.2143 47.5C88.2143 25.0141 69.9859 6.78571 47.5 6.78571C25.0141 6.78571 6.78571 25.0141 6.78571 47.5C6.78571 69.9859 25.0141 88.2143 47.5 88.2143ZM47.5 95C73.7335 95 95 73.7335 95 47.5C95 21.2665 73.7335 0 47.5 0C21.2665 0 0 21.2665 0 47.5C0 73.7335 21.2665 95 47.5 95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4993 62.2035C54.6631 62.2035 58.5241 58.1251 60.3868 54.8655C61.3165 53.2385 63.389 52.6733 65.016 53.603C66.6429 54.5326 67.2081 56.6052 66.2785 58.2321C63.6173 62.8891 57.8246 68.9893 47.4993 68.9893C37.0539 68.9893 31.9086 62.7258 28.9051 58.5208C27.8159 56.996 28.1691 54.877 29.6939 53.7879C31.2187 52.6988 33.3377 53.0519 34.4268 54.5767C37.0781 58.2884 40.4557 62.2035 47.4993 62.2035Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3212 36.1909C37.3212 39.3139 34.7895 41.8457 31.6665 41.8457C28.5434 41.8457 26.0117 39.3139 26.0117 36.1909C26.0117 33.0679 28.5434 30.5361 31.6665 30.5361C34.7895 30.5361 37.3212 33.0679 37.3212 36.1909Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9882 36.1909C68.9882 39.3139 66.4565 41.8457 63.3335 41.8457C60.2104 41.8457 57.6787 39.3139 57.6787 36.1909C57.6787 33.0679 60.2104 30.5361 63.3335 30.5361C66.4565 30.5361 68.9882 33.0679 68.9882 36.1909Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happy_face.4ae41dd6.svg";
export { ForwardRef as ReactComponent };